import React from 'react';
import SEO from '../components/SEO';
import Header from '../components/Header';
import Mantra from '../components/Mantra';
import PlanOptions from '../components/PlanOptions';
import AboutRImage from '../components/AboutRImage';
import CTA from "../components/CTA";
import InfoPlans from "../components/InfoPlans";
import Footer from '../components/Footer';
import '../styles/App.css';
import MantraImage from '../assets/images/Mantra_3.png';
import AboutRI from '../assets/images/AboutRI_Image.png';
import CTAImage from "../assets/images/CTA_Coach.png";



function Home() {
  const PlanOptionsContent = {
	sectionTitle: (
	  <>
		Plans<br /><span style={{ color: 'red' }}>& Pricing</span>
	  </>
	),
	sectionDescription:
	  'Our pricing plans are designed to meet the needs of a full-time coach, club coach, skill-development coach or engaged parent.',
	options: [
	  {
		title: '1:1 Coaching/Family',
		subtitle: 'Professional Facilities',
		body: (
		  <>
			<p>Ideal for parents working with their child or coaches training 1-4 athletes.</p>
			
			<p>This short-term use package gives you access to professional equipment and facilities for focused, individualized sessions.</p>
			
			<p className="notes">*Professional Liability Insurance required if Athletes are not related to coach.</p>
			
			<p className="price"> 
			<ul>
			<li>$100 per month</li>
			<li>3-month contract</li>
			</ul>
			</p>
			
			<p className="price-notes">*Great for Off-Season Skill work</p>
		  </>
		),
	  },
	  {
		title: 'Small Groups',
		subtitle: 'Focus & Flexibility',
		body: (
		  <>
			<p>
			  Perfect for coaches managing pre-season and in-season training for rosters of 1-8 athletes. 
			</p>
			<p>
			  This plan offers a dedicated space for small teams to build strength, endurance, and teamwork over a six-month contract.
			</p>
			
			<p className="notes">*Professional Liability Insurance required.</p>
			
			<p className="price"> 
			<ul>
			<li>$150 per month</li>
			<li>6-month contract</li>
			</ul>
			</p>
			
			<p className="price-notes">*Pre-Season Training & In-Season Practices</p>
			
		  </>
		),
	  },
	  {
		title: 'Teams',
		subtitle: 'Support For Coaches',
		body: (
		  <>
			<p>
			 For coaches with larger groups or clubs, our team package supports both 1:1 and group training, as well as team sessions. 
			</p>
			<p>
			  This plan accommodates the off-season and in-season needs of your athletes, providing the ultimate flexibility for your coaching schedule.
			</p>
			
			<p className="notes">*Professional Liability Insurance required.</p>
			
			<p className="price"> 
			<ul>
			<li>$250 per month</li>
			<li>12-month contract</li>
			</ul>
			</p>
			
			<p className="price-notes">*Year Round Training with In-Season Practices</p>
		  </>
		),
	  },
	],
  };
  
  // Example content for InfoPlans
	const infoItems = [
	  { title: '1:1', description: 'Lifestyle of Fitness' },
	  { title: 'Family', description: 'Off-Season Development' },
	  { title: 'Small Groups', description: 'Pre-Season & In-Season' },
	  { title: 'Teams', description: 'Year-Round Training' },
	];

  return (
	<div className="home">
	  <SEO
		title="Plans & Pricing"
		description="Pricing plans designed for coaches, families, and teams. From 1:1 coaching to team packages with year-round training access."
		image="/social-media-image.png"
		path="/plans"
	  />
	  <Header />
	  <main>
		<PlanOptions
		  sectionTitle={PlanOptionsContent.sectionTitle}
		  sectionDescription={PlanOptionsContent.sectionDescription}
		  options={PlanOptionsContent.options}
		/>
		<InfoPlans
		  sectionTitle={
			<>
			  Add-ons & <span style={{ color: 'red' }}>Reservations</span>
			</>
		}
		  sectionDescription="Our membership plans are designed to support individuals, families, small groups, and teams at all stages of training."
		  items={infoItems}
		/>
		<CTA
		  title={
			<>
			Interested In <span style={{ color: 'red' }}>Co-working?</span>
			</>
			}
		  description={
		  <>
		  <p>Need a professional gym and office space?</p>
		  
		  <p>We will offer a limited number of seats in our co-working space, designed specifically for coaches, trainers, and professionals who want to stay close to the action while maintaining focus and privacy.</p>
		  
		  </>
		}
		  imageSrc={CTAImage}
		  primaryButtonText="Send Info"
		  primaryButtonLink="#"
		/>
		
		<Mantra
		  backgroundImage={MantraImage}
		  mantraText="Begin Your Strength Journey"
		/>
		
		<AboutRImage
		  title={
		  <>
		  Frequently Asked <span style={{ color: 'red' }}>Questons</span>
		  </>
		  }
		  
		  copy={
			<>
				<p>Got questions? We’ve got answers.</p> 
				
				<p>Explore our FAQs to learn more about our facility, coaching, schedule, and what makes our approach different.
</p>
			</>
		  }
		  imageSrc={AboutRI}
		  primaryButtonText="FAQs"
		  primaryButtonLink="/faqs"
		  secondaryButtonText="About Us"
		  secondaryButtonLink="/about"
		/>
		
		<Footer />
	  </main>
	</div>
  );
}

export default Home;